import type { ThemeDefinition } from "vuetify";

export const defaultTheme: ThemeDefinition = {
    dark: false,
    colors: {
        background: "#ffffff",
        surface: "#f5f5f5",
        primary: "#587BA4",
        secondary: "#93a3b6",
        error: "#e74c3c",
        success: "#4CAF50",
        warning: "#FF9800",
        info: "#2196F3"
    },
    variables: {
        "body-font-family": '"DM Sans", "Helvetica", sans-serif',
        "headings-font": '"DM Sans", "Helvetica", sans-serif',
        "text-font": '"DM Sans", "Helvetica", sans-serif',

        "page-border-radius": "none",

        "status-timeline-icon-border-radius": "none",

        "sections-border-width": 0,
        "sections-shadow": "none",
        "sections-shadow-opacity": 0.5,

        "header-border-width": 1,
        "header-shadow": "none",
        "header-shadow-opacity": 0.5,
        "header-logo-type": "logo_color",
        "header-icon-type": "icon_color",
        "header-style": "classic",
        "header-displayed-text": "none"
    }
};
